





































































import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { Watch } from 'vue-property-decorator';
import { ResultPagDTO, PaginationSyncDTO } from '../../../interfaces/base-dto';
import { FiltroGrupoEnteralParmDTO, GrupoEnteralListItemDTO } from '@/interfaces/enteral';
import GrupoEnteralForm from '@/components/enteral/enteral-group-form.vue';
import * as service from '@/services/enteral-group';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    GrupoEnteralForm,
  },
})
export default class EnteralGroup extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public id: Number = null;
  private filtros: FiltroGrupoEnteralParmDTO = new FiltroGrupoEnteralParmDTO();
  private items: GrupoEnteralListItemDTO[] = [];

  private unidade: any = {};

  public headers: any = [
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Usuário alteração', value: 'alteradoPor', sortable: false },
    { text: 'Data', value: 'ultimaAlteracao', sortable: false },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  public pagina: ResultPagDTO<GrupoEnteralListItemDTO> = new ResultPagDTO<GrupoEnteralListItemDTO>();

  private mounted(): void {
    this.pesquisar();
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  private onChangeSearch() {
    if (this.loading) {
      return;
    }
    this.pesquisar();
  }

  private pesquisar() {
    this.loading = true;
    this.error = false;
    this.filtros.page = this.pagination.page;
    this.filtros.size = this.pagination.rowsPerPage;
    this.addSubsc(
      service.getEnteralsGroups(this.filtros).subscribe(
        (result) => {
          this.loading = false;
          this.pagina = result;
          this.items = this.pagina.content;
          PaginationSyncDTO.update(this.pagination, result);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  private newItem(): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = null;
  }

  private onEditItem(item): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = item.id;
  }

  private closeForm(): void {
    this.formOpen = false;
    this.id = null;
  }

  private saveItem(): void {
    this.closeForm();
    this.pesquisar();
  }
}
